import { vacancyVisibility } from '../../enums';
import { safeGet } from '../../functions';

// eslint-disable-next-line import/prefer-default-export
export function isLocked(vacancy) {
  return safeGet(vacancy, ['visibility']) === vacancyVisibility.INVITATION;
}
